














































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import api from "@/ts/functions";
import fieldData from "@/ts/FormData";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import ReportingPeriod from '@/views/reporting/ReportingPeriod.vue';
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';
import { INonResidentialHaulerVueModel } from "@/ts/models/INonResidentialHaulerVueModel";

@Component({
    props: {
        form: {
            type: Object as () => INonResidentialHaulerVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        ReportingPeriod, VueSimpleSuggest
    }
})
export default class NonResidentialHaulerFacilityInfo extends Vue {
    name: string = "NonResidentialHaulerFacilityInfo";
    title: string = "";
    facilitiesDb: any = null;
    facilities: any = null;
    facility: any = null;
    errorMsgs = ErrorMessages;
    isReportingPeriodError: boolean = false;
    toolTipText: string = "Select one region per report. Regions should generally be separated by north, west and south. The listing on page 2 is a suggestion of municipalities to include in each regional report. A hauler may choose to include municipalities listed under a different region when it is reasonable to do so.";
    
    mounted() {
        this.title = this.$props.vueStates.views[0].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 0);

        api.getFacilities("Hauler")
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim);
            });


        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[0].error = this.hasErrors;
        }, { immediate: true });


        this.$props.vueStates.views[0].visited = true;
    }

    get isHaulerNameError(): boolean {
        var match: any = null;
        if (this.$props.form.facilityId != null) {
            return false;
        }
        if (this.facilitiesDb != null) {
            match = this.facilitiesDb.filter((f: any) => f.facilityNameSelect === this.$props.form.haulerName);
            if (match.length > 0) {
                var objectId = this.$props.form.haulerName.substring(this.$props.form.haulerName.lastIndexOf('-') + 2);
                this.facility = this.facilitiesDb.find((f: any) => f.objectId == objectId);

                this.$props.form.haulerName = this.facility.facilityName;
                this.$props.form.facilityId = objectId;

                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    get isRegionError(): boolean {
        return func.isNullOrEmpty(this.$props.form.cookCountyRegion);
    }

    get isSiteCountError(): boolean {
        return func.isNullOrEmpty(this.$props.form.nonResidentialSiteCount) || this.$props.form.nonResidentialSiteCount < 0;
    }

    get isSitesServicedError(): boolean {
        return func.isNullOrEmpty(this.$props.form.nonResidentialSitesServiced) || this.$props.form.nonResidentialSitesServiced < 0;
    }

    get isHaulerError(): boolean {
        return func.isNullOrEmpty(this.$props.form.isHauler)
    }        

    get isReportingYearError(): boolean {
        return this.$props.form.reportingPeriod == null
    }

    get hasErrors(): boolean {
        return this.isHaulerNameError || this.isRegionError || this.isSiteCountError || this.isSitesServicedError || this.isReportingPeriodError || this.isHaulerError || this.isReportingYearError;
    }
}
